export const selectServiceContractType = {
    bindings: {
        module: '@',
        identifier: '@'
    },
    template: require('./select-service-contract-type.html'),
    controller: 'SelectServiceContractTypeController'
};
